export default function messageOnSourceDownload(status) {
    let message

    switch (status) {
        case 200:
            message = 'Código-fonte baixado com sucesso.'
            break
        case 403:
            message = 'Você não está autorizado a baixar esse eitri-app.'
            break

        default:
            message = 'Houve um erro ao baixar código-fonte do eitri-app.'
            break
    }

    return message
}
